// extracted by mini-css-extract-plugin
module.exports = {"bulletList":"BulletList_bulletList__UXjok","compactBulletList":"BulletList_compactBulletList__dvRnZ"};